import axios from 'axios';

export const fetchData = async (query, constellation) => {
  try {
    const conValue = constellation === '狮子座' ? 0 : 1;
    
    // 创建 FormData 对象
    const formData = new FormData();
    formData.append('name', query);
    formData.append('con', conValue);
    formData.append('ip', 'leeuu.adil.com.cn');
    
    // 使用 axios.post() 发起 POST 请求
    const response = await axios.post('https://leeuuapi.adil.com.cn/leeuu_api/selectsupda_waizhan.ashx', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      }
    });

    // 打印响应数据结构

    // 如果数据格式符合预期，处理数据
    if (response.data && response.data.length) {
      const data = response.data;
      return data.map(([name, items]) => ({
        name,
        items: items
          .map(item => ({
            name: item.name,
            price: item.such,
            supermarket_name: item.supername,
            address: item.source,
            room_name: item.housename
          }))
          .sort((a, b) => a.price - b.price) // 按价格由小到大排序
      }));
    } else {
      console.error('返回数据为空或格式不正确');
      return [];
    }
  } catch (error) {
    console.error('数据请求失败', error);
    throw new Error('数据请求失败');
  }
};

export async function fetchUpdateTimes() {
    try {
        const response = await fetch('https://leeuuapi.adil.com.cn/sjgxtime.ashx');
        const data = await response.text();
        
        // 创建一个临时的 DOM 元素来解析 HTML
        const parser = new DOMParser();
        const doc = parser.parseFromString(data, 'text/html');
        
        // 获取所有行
        const rows = doc.querySelectorAll('tr');
        
        const result = {};
        
        // 从第二行开始遍历（跳过表头）
        for (let i = 1; i < rows.length; i++) {
            const cells = rows[i].querySelectorAll('th, td');
            const constellation = cells[0].textContent.trim();
            const earliestUpdate = cells[1].textContent.trim();
            const latestUpdate = cells[2].textContent.trim();
            
            result[constellation] = {
                earliest: earliestUpdate,
                latest: latestUpdate
            };
        }
        
        return result;
    } catch (error) {
        console.error('获取更新时间失败:', error);
        throw error;
    }
}

export async function fetchDesigners() {
    try {
        const response = await axios.get('https://apileeuu.adil.com.cn/leeuu/users', {
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }
        });
        return response.data.map(item => ({
            id: item.user_id,
            name: item.name,
            description: item.description,
            avatar: item.avatar,
            screenshot: item.screenshot
        }));
    } catch (error) {
        console.error('获取设计师数据失败:', error);
        throw error;
    }
}

export async function fetchDesignerWorks(userId) {
    try {
        const response = await axios.get(`https://apileeuu.adil.com.cn/leeuu/works?user_id=${userId}`, {
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }
        });
        return response.data.map(item => {
            let imageUrl = item.image_url;
            // 处理图片URL
            if (imageUrl) {
                if (imageUrl.startsWith('https//')) {
                    imageUrl = imageUrl.replace('https//', 'https://');
                } else if (!imageUrl.startsWith('http')) {
                    imageUrl = `https://${imageUrl}`;
                }
            }
            return {
                id: item.id,
                title: item.work_name,
                description: item.description,
                specs: `${item.level}级 / ${item.type || '通用'}`,
                price: item.price,
                image: imageUrl
            };
        });
    } catch (error) {
        console.error('获取设计师作品失败:', error);
        throw error;
    }
}
